module.exports = __webpack_public_path__ + "static/media/tab-img-4.08f928fa.jpg";